// AdminChoralWorkspace.jsx — authenticated editorial workspace.
import React from "react";
import ChoralEditorialWorkspace from "@/features/choral-editorial/ChoralEditorialWorkspace";

export default function AdminChoralWorkspace({ isOwner = false }) {
  return (
    <ChoralEditorialWorkspace
      apiBase="/api/admin/choral"
      canVerify={!!isOwner}
      readOnly={false}
    />
  );
}
